import axios from "axios";
import { getUrlApi } from "../utils/util";

class UserService {
    async getById(id) {
        var url = `${await getUrlApi()}/user`;
        return axios.get(`${url}/${id}`, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }

    async validate(user) {
        var url = `${await getUrlApi()}/public/user`;
        return axios.post(`${url}/validate`, user);
    }

    async createCustomer(user) {
        var url = `${await getUrlApi()}/public/user`;
        return axios.post(`${url}/createcustomer`, user);
    }

    async resendEmail(email) {
        var url = `${await getUrlApi()}/public/user`;
        return axios.post(`${url}/resendemail?email=${email}`);
    }

    async activateUser(token) {
        var url = `${await getUrlApi()}/public/user`;
        return axios.get(`${url}/email/${token}`);
    }

    async generateToken(authorization, phone) {
        var url = `${await getUrlApi()}/user/generatetoken`;

        if (phone !== null && phone !== undefined) {
            url += "?phone=" + phone;
        }

        return axios.get(url, {
            headers: { authorization: "Bearer " + authorization },
        });
    }

    async updateRegister(authorization, token, document, phone) {
        var url = `${await getUrlApi()}/user/updateregister?token=${token}&document=${document}&phone=${phone}`;

        return axios.get(url, {
            headers: { authorization: "Bearer " + authorization },
        });
    }

    async requestPasswordReset(email) {
        var url = `${await getUrlApi()}/public/user`;
        return axios.get(`${url}/requestpasswordreset?email=${email}`);
    }

    async resetPassword(token, newPassword) {
        var url = `${await getUrlApi()}/public/user`;
        return axios.post(`${url}/resetpassword`, { token, newPassword });
    }
    
}

export default new UserService();
